/* @flow */
import React, { Component } from 'react';
import Chart from 'chart.js/src/chart';

let chartId = 0;

const nextId = () => `chartjs-${chartId++}`; // eslint-disable-line no-plusplus

const styles = {
  colours: {
    background: [
      'rgba(255, 99, 132, 0.2)',
      'rgba(54, 162, 235, 0.2)',
      'rgba(255, 206, 86, 0.2)',
      'rgba(75, 192, 192, 0.2)',
      'rgba(153, 102, 255, 0.2)',
      'rgba(255, 159, 64, 0.2)',
    ],
    border: [
      'rgba(255,99,132,1)',
      'rgba(54, 162, 235, 1)',
      'rgba(255, 206, 86, 1)',
      'rgba(75, 192, 192, 1)',
      'rgba(153, 102, 255, 1)',
      'rgba(255, 159, 64, 1)',
    ],
  },
};

type Props = {
  data: Object,
  type?: string,
  options?: Object,
  height?: number,
  width?: number,
};

type State = {
  ctx: string,
  options?: Object,
  data: Object,
};

export default class MyChart extends Component<Props, State> {
  // eslint-disable-next-line react/sort-comp
  chart: Object;

  constructor(props: Props) {
    super(props);

    props.data.datasets.forEach(dataset => {
      if (!('backgroundColor' in dataset)) {
        // eslint-disable-next-line no-param-reassign
        dataset.backgroundColor = styles.colours.background;
      }

      if (!('borderColor' in dataset)) {
        // eslint-disable-next-line no-param-reassign
        dataset.borderColor = styles.colours.border;
      }
    });

    this.state = {
      ctx: nextId(),
      options: props.options,
      data: props.data,
    };
  }

  componentDidMount() {
    const { type = 'bar' } = this.props;
    const { ctx, data, options } = this.state;

    this.chart = new Chart(ctx, {
      type,
      data,
      options,
    });
  }

  componentWillUnmount() {
    this.chart.destroy();
  }

  render() {
    const { height, width } = this.props;
    const { ctx } = this.state;

    return (
      <div style={{ width, height }}>
        <canvas id={ctx} width={width} height={height} />
      </div>
    );
  }
}

export { styles };



// WEBPACK FOOTER //
// ./src/components/chart/Chart.js